import styled from '@emotion/styled';

import useInquiryForm from './hooks/useInquiryForm';
import InquiryFormContents from './InquiryFormContents';
import InquiryFormFooter from './InquiryFormFooter';

/**
 * 1:1 문의 폼
 * @constructor
 */
function InquiryWriteForm() {
    const formValues = useInquiryForm();
    const { reset, handleCreateInquiry } = formValues;
    return (
        <Container>
            <InquiryFormContents values={formValues} />
            <InquiryFormFooter reset={reset}
                handleCreateInquiry={handleCreateInquiry} />
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
`;

export default InquiryWriteForm;
